import { toastr } from 'react-redux-toastr';
import {
    pendingTask,
    begin,
    end,
} from 'react-redux-spinner';
import { LOADING_START, LOADING_END } from '../../../store/loading';
import { UPDATE_EMPLOYEE_GLOBAL_SETUP } from './globalSetup.actions';
import {
    getEmployeeGlobalSetup,
} from '../../services/api-endpoints';
import i18n from '../../../services/i18n';

/** @type { () => (dispatch: import('redux').Dispatch) => void} */
export const fetchEmployeeGlobalSetup = () => async (dispatch) => {
    dispatch({ type: LOADING_START, [pendingTask]: begin });

    try {
        const { data: employeeGlobalResponse } = await getEmployeeGlobalSetup();

        dispatch({
            type: UPDATE_EMPLOYEE_GLOBAL_SETUP,
            payload: {
                ...employeeGlobalResponse,
                isGlobalSetupDataLoaded: true,
                reset: employeeGlobalResponse,
            },
        });
    } catch (error) {
        // @ts-ignore
        toastr.error(i18n.t('shiftBidding:toastr.loadingAppData'), error.response?.data?.Message || i18n.t('shiftBidding:toastr.failedToLoad'));
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
